import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";

import { ResetPassword } from "shared/components/Auth/ResetPassword";
import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import { initSentry } from "shared/helpers/utils";

import "i18n";

import "@brandAssets/scss/reset-password.scss";

initSentry();

ReactDOM.createRoot(document.getElementById("reset-password")).render(
  <ErrorBoundary>
    <ResetPassword />
  </ErrorBoundary>
);

reportWebVitals(console.log);
